import React, { Component, Fragment } from 'react';
import { BreadCrumb } from '../../components/BreadCrumb';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { Loading, Card, HistoryPeriod, Validator, ErrorMessage } from '../../components';
import { UserAccounts } from '../../components/UserAccounts';
import { Tooltip } from 'reactstrap';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../helpers/DataTableColumns';
import { TransferOptionService } from '../../services/TransferOptionService';
import { InternalTransferService } from '../../services/InternalTransferService';


export class InternalTransfer extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            confirm: false,
            loading: false,
            success: false,
            fromAccount: {
                login: "",
                availableMargin: 0.0,
                accountCurrency: ""
            },
            toAccount: {
                login: "",
                availableMargin: 0.0,
                accountCurrency: ""
            },
            amount: 0,
            InternalTransferHistory: [],
            allMargin: false,
            validation: {
                error: false,
                message: ""
            }
        }

    }
    componentWillMount() {
        this.onPeriodChange();
    }
    onPeriodChange(key) {

        this.setState({ loading: true, period: key }, () => {

            TransferOptionService.InternalTransfer.Page(key).then(response => {

                if (response) {
                    this.setState({
                        loading: false,
                        InternalTransferHistory: response.history,
                        settings: response.settings,
                        disabled: response.disabled
                    });
                }
                else {
                    this.setState({
                        loading: false
                    })
                }

            });

        });
    }
    changeAccount(userAccount, key) {

        this.setState({
            [key]: {
                login: userAccount.active,
                availableMargin: userAccount.info.availableMargin,
                accountCurrency: userAccount.info.currency
            },
            amount: 0
        }, () => {

            if (key === "fromAccount" && this.state.allMargin)
                this.setState({ amount: this.state.fromAccount.availableMargin });

        })
    }
    onChangeForm(e, key) {

        let value = e.target.value;

        if (key === "amount" && parseFloat(value) > this.state.fromAccount.availableMargin)
            value = this.state.fromAccount.availableMargin;

        this.setState({
            [key]: value
        });
    }
    onChecked() {
        this.setState({
            allMargin: !this.state.allMargin
        }, () => {
            if (this.state.allMargin) {
                this.setState({
                    amount: this.state.fromAccount.availableMargin
                })
            } else {
                this.setState({
                    amount: 0
                })
            }
        });
    }
    onAvailableMargin() {

        this.setState({
            amount: this.state.fromAccount.availableMargin
        });
    }
    onToggleConfirm() {
        if (this.onValid())
            this.setState({ confirm: !this.state.confirm });
    }
    onConfirm() {

        this.setState({ loading: true }, () => {

            InternalTransferService.Create({
                fromAccount: this.state.fromAccount.login,
                toAccount: this.state.toAccount.login,
                amount: this.state.amount,
                allMargin: this.state.allMargin
            }).then(response => {

                if (response | response.error === false) {

                    TransferOptionService.InternalTransfer.History(this.state.period).then(response => {

                        if (response) {
                            this.setState({
                                InternalTransferHistory: response,
                                loading: false,
                                success: true
                            });
                        } else {

                            this.setState({ loading: false });
                        }
                    });

                } else {

                    if (response.error) {

                        this.setState({
                            validation: {
                                error: response.error,
                                message: response.message
                            },
                            loading: false
                        });
                    }
                }

            });
        });

    }
    onValid() {

        if (!this.state.confirm) {

            let error = Validator.Valid({
                fromAccount: this.state.fromAccount.login,
                toAccount: this.state.toAccount.login,
                amount: this.state.amount
            }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;

    }
    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title="Loading Content" />
                        <BreadCrumb Title="Internal Transfer" Name="Internal Transfer" />
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card mini-stat">
                                            <div className="card-body">
                                                <div className="mb-4">
                                                    <div className="float-left mini-stat-img mr-4 bg-success text-white">
                                                        <i className="far fa-credit-card font-30"></i>
                                                    </div>
                                                    <h5 className="font-16 text-uppercase mt-0">{Translate('From Account')}</h5>
                                                    <p className="font-400 text-muted">{Translate('Please select the account you want to process.')}</p>
                                                </div>
                                                <div className="pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <UserAccounts Select OnlyInfo Witdrawal className="bg-success" Change={(e, userAccount) => this.changeAccount(userAccount, "fromAccount")} Filter={this.state.toAccount.login} Status="from" />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <dl className="row mb-0">
                                                                <dt className="col-sm-8">{Translate('Available Margin')}</dt>
                                                                <dd className="col-sm-4 text-ellipsis">{this.state.fromAccount.availableMargin.toFixed(2)}</dd>                                                               
                                                            </dl>
                                                            <dl className="row mb-0">                                                                
                                                                <dt className="col-sm-8">{Translate('Account Currency')}</dt>
                                                                <dd className="col-sm-4">{this.state.fromAccount.accountCurrency} &nbsp;</dd>
                                                            </dl>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="card mini-stat">
                                            <div className="card-body">
                                                <div className="mb-4">
                                                    <div className="float-left mini-stat-img mr-4 bg-info text-white">
                                                        <i className="far fa-credit-card font-30"></i>
                                                    </div>
                                                    <h5 className="font-16 text-uppercase mt-0">{Translate('To Account')}</h5>
                                                    <p className="font-400 text-muted">{Translate('Please select an account to transfer.')}</p>
                                                </div>
                                                <div className="pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <UserAccounts Select OnlyInfo className="bg-info" Change={(e, userAccount) => this.changeAccount(userAccount, "toAccount")} Filter={this.state.fromAccount.login} Status="to" />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <dl className="row mb-0">
                                                                <dt className="col-sm-8">{Translate('Available Margin')}</dt>
                                                                <dd className="col-sm-4 text-ellipsis">{this.state.toAccount.availableMargin.toFixed(2)}</dd>
                                                            </dl>
                                                            <dl className="row mb-0">
                                                                <dt className="col-sm-8">{Translate('Account Currency')}</dt>
                                                                <dd className="col-sm-4">{this.state.toAccount.accountCurrency} &nbsp;</dd>
                                                            </dl>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-12">
                                        <form className="form-horizontal" name="internalTransferForm" ref={this.Refs}>
                                            <fieldset disabled={this.state.disabled}>
                                                <div className="card mini-stat">
                                                    <div className="card-body">
                                                        <div className="mb-4">
                                                            <div className="float-left mini-stat-img mr-4 bg-warning text-white">
                                                                <i className="fas fa-info font-30"></i>
                                                            </div>
                                                            <h5 className="font-16 text-uppercase mt-0">{Translate('Transfer Detail')}</h5>
                                                            <p className="font-400 text-muted">{Translate('Please enter information about your transfer process.')}</p>
                                                        </div>
                                                        <div className="pt-2">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group row">
                                                                        <label htmlFor="fromAccount" className="col-sm-6 col-form-label text-success">{Translate('From Account')}</label>
                                                                        <div className="col-sm-6">
                                                                            {this.state.confirm ?
                                                                                (<strong className="text-dark">{this.state.fromAccount.login}</strong>) :
                                                                                (<input className="form-control" type="number" value={this.state.fromAccount.login} id="fromAccount" name="fromAccount" readOnly />)}
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <label htmlFor="toAccount" className="col-sm-6 col-form-label text-info">{Translate('Account')}</label>
                                                                        <div className="col-sm-6">
                                                                            {this.state.confirm ?
                                                                                (<strong className="text-dark">{this.state.toAccount.login}</strong>) :
                                                                                (<input className="form-control" type="number" value={this.state.toAccount.login} id="toAccount" name="toAccount" readOnly />)}
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <label htmlFor="amount" className="col-sm-6 col-form-label">{Translate('Transfer Amount')}</label>
                                                                        <div className="col-sm-6 input-group">
                                                                            {this.state.confirm ?
                                                                                (<strong className="text-dark">{this.state.amount} {this.state.toAccount.accountCurrency}</strong>) :
                                                                                (<Fragment>
                                                                                    <input className="form-control" type="number" id="amount" name="amount" value={this.state.amount} onChange={(e) => this.onChangeForm(e, "amount")} onFocus={e => e.target.select()} readOnly={this.state.allMargin} />
                                                                                    <div className="input-group-append hide">
                                                                                        <button type="button" className="input-group-text pt-0 pb-0 bg-white" id="availableMargin" onClick={(e) => this.onAvailableMargin()}>
                                                                                            {this.state.fromAccount.availableMargin.toFixed(2) + " " + this.state.fromAccount.accountCurrency}
                                                                                        </button>
                                                                                        <Tooltip placement="right" isOpen={this.state.tooltipAvailableMargin} target="availableMargin" toggle={() => this.setState({ tooltipAvailableMargin: !this.state.tooltipAvailableMargin })}>
                                                                                            {Translate("Available Margin")}
                                                                                        </Tooltip>
                                                                                    </div>
                                                                                </Fragment>)}

                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row">
                                                                        <label htmlFor="example-number-input" className="col-sm-6 col-form-label">{Translate('Send All Availble Margin')}</label>
                                                                        <div className="col-sm-6">
                                                                            {this.state.confirm ?
                                                                                (<strong className="text-dark mb-4 mt-2 d-block">{this.state.allMargin ? Translate("Yes") : Translate("No")}</strong>) :
                                                                                (<Fragment>
                                                                                    <input type="checkbox" id="switch9" switch="dark" defaultChecked={this.state.allMargin} onChange={(e) => this.onChecked()} />
                                                                                    <label htmlFor="switch9" data-on-label={Translate("Yes")} data-off-label={Translate("No")} className="mt-2 mb-1"></label>
                                                                                </Fragment>)}
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group row mb-1">
                                                                        {this.state.success ?
                                                                            (
                                                                                <div className="col-sm-12">
                                                                                    <div className="row">
                                                                                        <div className="col-sm-3">
                                                                                            <button type="button" className="btn btn-lg btn-info" onClick={(e) => window.location.reload(true)}><i className="fas fa-sync-alt"></i> &nbsp; {Translate("Refresh Page")}</button>
                                                                                        </div>
                                                                                        <div className="col-sm-9">
                                                                                            <div className="alert alert-success m-0" role="alert">
                                                                                                <strong><i className="far fa-check-circle"></i> {Translate("Request Received!")}</strong>{Translate("Your internal transfer was successful.")} 
                                                                                        </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) :
                                                                            (
                                                                                <Fragment>
                                                                                    <div className="col-sm-6 p-0">
                                                                                        <ErrorMessage Validation={this.state.validation} />
                                                                                    </div>
                                                                                    {this.state.confirm ?
                                                                                        (<div className="col-sm-6">
                                                                                            <button type="button" className="btn btn-lg btn-warning" onClick={(e) => this.onToggleConfirm()}><i className="fas fa-chevron-left"></i> &nbsp; {Translate("Cancel")}</button>
                                                                                            <button type="button" className="btn btn-lg btn-info float-right" onClick={(e) => this.onConfirm()}>{Translate("Confirm")} &nbsp; <i className="fas fa-chevron-right"></i></button>
                                                                                        </div>) :
                                                                                        (<div className="col-sm-6">
                                                                                            <button type="button" className="btn btn-lg btn-dark btn-block mb-1" onClick={(e) => this.onToggleConfirm()}>{Translate('Send Transfer Request')}</button>
                                                                                        </div>)}
                                                                                </Fragment>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <Card Title="Internal Transfer History" Description="Recent successful internal transfer" Tools={<HistoryPeriod onChange={(key) => this.onPeriodChange(key)} />}>
                                    {this.state.InternalTransferHistory.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>{Translate('No record!')}</strong> {Translate('You have no successful internal transfer.')} </em>
                                        </div>) : (
                                            <DataTable
                                                noHeader={true}
                                                columns={DataTableColumns.internalTransfer}
                                                data={this.state.InternalTransferHistory}
                                                defaultSortField="date"
                                                defaultSortAsc={false}
                                                pagination
                                                highlightOnHover />
                                        )}
                                </Card>
                            </div>
                        </div>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}